module.exports = __webpack_public_path__ + "static/media/taco_madera_para_eje.c73de03b.jpg";